import React from "react";
import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";

const CONTENT = {
  privacy: {
    title: "Privacybeleid", path: "/privacy",
    intro: "Imperium Group respecteert uw privacy en verwerkt persoonsgegevens zorgvuldig en conform de AVG.",
    sections: [
      { h: "Welke gegevens verzamelen wij?", p: "Wanneer u een formulier invult (offerteaanvraag of contact), verzamelen wij de gegevens die u verstrekt, zoals naam, bedrijfsnaam, e-mailadres, telefoonnummer en informatie over uw marketingvraag." },
      { h: "Waarvoor gebruiken wij uw gegevens?", p: "Wij gebruiken uw gegevens om uw aanvraag te behandelen, contact met u op te nemen en onze dienstverlening af te stemmen. Wij verkopen uw gegevens nooit aan derden." },
      { h: "Campagnegegevens", p: "Gegevens die wij in het kader van marketingcampagnes verwerken, behandelen wij volgens de met de opdrachtgever gemaakte afspraken en op basis van de vereiste toestemming." },
      { h: "Bewaartermijn", p: "Wij bewaren gegevens niet langer dan noodzakelijk voor de doeleinden waarvoor ze zijn verzameld." },
      { h: "Uw rechten", p: "U kunt uw gegevens inzien, corrigeren of laten verwijderen via info@imperiumgroup.nl." },
    ],
  },
  voorwaarden: {
    title: "Algemene voorwaarden", path: "/algemene-voorwaarden",
    intro: "Deze algemene voorwaarden zijn van toepassing op alle diensten, campagnes en samenwerkingen van Imperium Group.",
    sections: [
      { h: "Toepasselijkheid", p: "Deze voorwaarden gelden voor alle aanbiedingen, offertes, campagnes en overeenkomsten tussen Imperium Group en haar opdrachtgevers." },
      { h: "Dienstverlening", p: "Diensten worden geleverd volgens de per opdracht afgesproken scope, kanalen en voorwaarden. Omvang, doorlooptijd en media-inzet worden per project afgestemd." },
      { h: "Media-inkoop", p: "Bij media-inkoop (o.a. TV, radio, online en out-of-home) gelden de tarieven en voorwaarden van de betreffende media- en platformpartijen, naast de afspraken met Imperium Group." },
      { h: "Prijzen en betaling", p: "Genoemde prijzen zijn indicatief en afhankelijk van de gemaakte afspraken. Een definitieve offerte wordt per project opgesteld." },
      { h: "Aansprakelijkheid", p: "Imperium Group spant zich in om diensten en campagnes naar behoren te leveren, maar geeft geen garantie op specifieke conversie- of verkoopresultaten." },
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  useSeo({ title: `${c.title} | Imperium Group`, description: c.intro, path: c.path });

  return (
    <div data-testid={`${type}-page`}>
      <PageHero overline="Juridisch" title={c.title} subtitle={c.intro} />
      <section className="pb-24">
        <div className="mx-auto max-w-3xl space-y-6 px-6 lg:px-10">
          {c.sections.map((s, i) => (
            <div key={i} className="rounded-2xl border border-white/10 bg-[#12151D] p-8">
              <h2 className="font-display text-xl font-semibold text-white">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-slate-400">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
